import React from "react";
import project from "../../image/project.png";
import aspin from "../../image/aspin.jpg";
import pid from "../../image/p&id.jpg";
import elarning from "../../image/elarning.png";
import eticket from "../../image/eticket.jpeg";
import bus_ticket from "../../image/bus_ticket.png";

import { useSpring, animated } from "@react-spring/web";
import "./style.css";

import ScrollAnimation from "react-animate-on-scroll";
import { BsFillPatchCheckFill } from "react-icons/bs";

const Page1 = () => {
  const styles = useSpring({
    loop: { reverse: true },
    from: { x: 0 },
    to: { x: 100 },
  });

  return (
    <div
      className="container"
      style={{ marginBottom: "150px", marginTop: "100px" }}
    >
      <ScrollAnimation animateIn="tada" initiallyVisible={true}>
        <div class="row">
          <div class="pro2">
            <p class="small-title">
              Build{" "}
              <strong style={{ color: "red", fontWeight: "bold" }}>
                e-Learning
              </strong>{" "}
              Platform
            </p>

            <p>Full website UI design and Front and Backend Coding</p>
          </div>

          <div class="pro2">
            <p>DATE</p>
            <p>December 2021</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <p class="heading-num">Features</p>
            <div class="pro2">
              <p>
                <BsFillPatchCheckFill /> Streamlined course selection and secure
                transactions with easy payment methods.
              </p>
              <p>
                <BsFillPatchCheckFill /> Centralized Student Information
                Management Dashboard for seamless personal data control.
              </p>
              <p>
                <BsFillPatchCheckFill /> Two-factor authentication ensures a
                secure and hassle-free signup or login experience.
              </p>
              <p>
                <BsFillPatchCheckFill /> Effortlessly enroll in multiple courses
                to tailor your learning journey.
              </p>

              <div style={{ marginTop: "50px", marginBottom: "100px" }}>
                <animated.div
                  style={{
                    width: "20%",
                    height: 50,
                    backgroundColor: "rgba(255, 255, 255, 0)",
                    borderRadius: 16,
                    ...styles,
                  }}
                >
                  <button
                    onClick={() =>
                      (document.location.href = "https://aibengal.web.app/")
                    }
                    class="card1but"
                  >
                    {" "}
                    <a class="card1front1" href="https://aibengal.web.app/">
                      Live Demo
                    </a>{" "}
                  </button>{" "}
                </animated.div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <img src={elarning} class="img-fluid" alt={""} />
          </div>
        </div>
      </ScrollAnimation>

      <ScrollAnimation animateIn="fadeInLeftBig" initiallyVisible={true}>
        <div class="row">
          <div class="pro2">
            <p class="small-title">
              Build an
              <strong style={{ color: "red", fontWeight: "bold" }}>
                {""} e-bus ticket
              </strong>{" "}
              platform
            </p>
            <p>Full website UI design and Front and Backend Coding</p>
          </div>

          <div class="pro2">
            <p>DATE</p>
            <p>February 2022</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <img src={eticket} class="img-fluid" alt={""} />
          </div>
          <div class="col-md-6">
            <p class="heading-num">Features</p>

            <div class="pro2">
              <p>
                {" "}
                <BsFillPatchCheckFill /> Users can effortlessly book bus tickets
                through a user-friendly interface.{" "}
              </p>
              <p>
                <BsFillPatchCheckFill /> Implement a robust login and
                registration system with 2-factor authentication for enhanced
                security.{" "}
              </p>
              <p>
                <BsFillPatchCheckFill /> Users can view and manage their
                upcoming and past bus trips, including details like departure
                times and seat assignments.
              </p>
              <p>
                <BsFillPatchCheckFill /> Provide users with real-time updates on
                bus schedules, delays, and other relevant information. Send
                notifications for booking confirmations, changes, or
                cancellations.
              </p>

              <div style={{ marginTop: "50px", marginBottom: "100px" }}>
                <animated.div
                  style={{
                    width: "20%",
                    height: 50,
                    backgroundColor: "rgba(255, 255, 255, 0)",
                    borderRadius: 16,
                    ...styles,
                  }}
                >
                  <button
                    onClick={() =>
                      (document.location.href = "https://eticketbusbd.web.app/")
                    }
                    class="card1but"
                  >
                    {" "}
                    <a class="card1front1" href="https://eticketbusbd.web.app/">
                      Live Demo
                    </a>{" "}
                  </button>{" "}
                </animated.div>
              </div>
            </div>
          </div>
        </div>
      </ScrollAnimation>

      <ScrollAnimation animateIn="fadeInLeftBig" initiallyVisible={true}>
        <div class="row">
          <div class="pro2">
            <p class="small-title">
              {" "}
              <strong style={{ color: "red", fontWeight: "bold" }}>
                Social media{" "}
              </strong>{" "}
              with{" "}
              <strong style={{ color: "red", fontWeight: "bold" }}>
                Pomodoro
              </strong>{" "}
              App
            </p>
            <p>Full website UI design and Front and Backend Coding</p>
          </div>

          <div class="pro2">
            <p>DATE</p>
            <p>Jun 2021</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <img src={project} class="img-fluid" alt={""} />
          </div>
          <div class="col-md-6">
            <p class="heading-num">Features</p>

            <div class="pro2">
              <p>
                {" "}
                <BsFillPatchCheckFill /> Student manage their study time with
                this app{" "}
              </p>
              <p>
                <BsFillPatchCheckFill /> Student can Login and register account
                with 2fa Authentication{" "}
              </p>
              <p>
                <BsFillPatchCheckFill /> Student can Post their question in
                their study group and update and delete their post{" "}
              </p>
              <p>
                <BsFillPatchCheckFill /> Student can like and comment and shear
                their question{" "}
              </p>

              <div style={{ marginTop: "50px", marginBottom: "100px" }}>
                <animated.div
                  style={{
                    width: "20%",
                    height: 50,
                    backgroundColor: "rgba(255, 255, 255, 0)",
                    borderRadius: 16,
                    ...styles,
                  }}
                >
                  <button
                    onClick={() =>
                      (document.location.href =
                        "https://salehbd.pythonanywhere.com/time")
                    }
                    class="card1but"
                  >
                    {" "}
                    <a
                      class="card1front1"
                      href="https://salehbd.pythonanywhere.com/time"
                    >
                      Live Demo
                    </a>{" "}
                  </button>{" "}
                </animated.div>
              </div>
            </div>
          </div>
        </div>
      </ScrollAnimation>

   
     
      <div class="row">
        <div class="col-sm-6">
          <div>
            <img
              src={pid}
              style={{ borderRadius: "50px" }}
              class="img-fluid"
              alt={""}
            />
          </div>

          <br />
        </div>

        <div class="col-sm-6" style={{ marginTop: "10px" }}>
          <h5 class="text-justify">
            Our academic discipline course code (CEP-454 plant design and
            process simulation) our goals to design urea plant process flow
            diagram then simulation. I use AutoCAD plant 3D for drawing p&id. I
            design Equipment and instrumentation specifications (EIS).
            Standards, Codes and Specifications and designations Mechanical
            instrumentation with names and numbers All valves and their
            identifications method piping, sizes, and special fittings, sampling
            lines, Flow directions Interconnections references management inputs
            and outputs, interlocks Interfaces s Computer system Identification
            of parts and subsystems delivered by the process.
          </h5>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <a href="https://drive.google.com/drive/folders/1ym8hfBQ-ywE7UDq5SIXyFiutFh40DN6v?usp=sharing">
              <h3 class="btn rounded btn btn-dark btn-sm">
                {" "}
                Autocad file and P&Id
              </h3>
            </a>
          </div>
        </div>

        <div class="col-sm-6" style={{ marginTop: "100px" }}>
          <h5 class="text-justify">
            I use aspinplusv10 for design heat exchanger and adsorption column.
            When I simulate adsorption column, my analysis shortcut method to
            rating analysis. When I get at a certain amount reflux ratio then I
            use sensitivity analysis for analysis what actual reflux ratio and
            what the actual number of stages, then plot the data and analysis
            the data. On the other hand, I design heat exchanger with rating
            model and calculate overall heat transfer coe icient and LMTD and
            required heat transfer area and generate the geometry of heat
            exchanger. All this calculation file is attached in given below.
          </h5>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <a href="https://drive.google.com/drive/folders/1AIoVCfJ44xfuXkiz2L9vf3gValNovV1B?usp=sharing">
              <h3
                style={{ marginTop: "10px" }}
                class="btn rounded btn btn-dark btn-sm"
              >
                Simulation file{" "}
              </h3>
            </a>
          </div>
        </div>

        <div class="col-sm-6" style={{ marginTop: "100px" }}>
          <img
            src={aspin}
            style={{ borderRadius: "50px" }}
            class="img-fluid"
            alt={""}
          />
        </div>
      </div>
    </div>
  );
};

export default Page1;
